<template>
    <mdc-dialog v-model="isOpen"
                class="client-modal"
                :title="!isEdit ? 'user.add_client' : 'user.edit_client' | trans"
                :accept="'user.save' | trans"
                :cancel="'user.cancel' | trans"
                :accept-disabled="disabled"
                @accept="close"
                @cancel="close"
                @validate="save">
        <div class="close-cross" @click="close()">
            <mdc-icon icon="close"></mdc-icon>
        </div>
        <loader v-if="!isLoaded" class="table-loader"></loader>
        <form enctype="multipart/form-data" novalidate>
            <div class="form-group row mb-2"
                 v-if="errors.has('isValidationError')">
              <div class="col-md-12">
                <span class="invalid-feedback-label">
                    <strong>{{ errors.first('isValidationError') }}</strong>
                </span>
              </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                    <v-select id="clinicalCenter"
                              name="clinicalCenter"
                              label="name"
                              :options="clinicalCentersNew"
                              :on-change="onChangeClinicalCenter"
                              :class="{'is-invalid': errors.has('clinicalCenter'), 'is-clear': !user.clinicalCenter}"
                              v-model="user.clinicalCenter"
                              v-validate="'required'"
                              data-vv-validate-on="none"
                              data-vv-name="clinicalCenter"
                              :data-vv-as="'user.clinical_center' | trans">
                        <template slot="no-options">
                            <div @mousedown.stop="">
                                {{ 'user.clinical_center_no_data' | trans }}
                            </div>
                        </template>
                        <template slot="option" slot-scope="option">
                            {{ option.name }}
                        </template>
                        <template slot="selected-option" slot-scope="option">
                            {{ option.name }}
                        </template>
                    </v-select>


                    <label class="mdc-floating-label"
                           :class="{ 'mdc-floating-label-error': errors.has('clinicalCenter') }">{{
                      'user.clinical_center' | trans }}</label>

                  <span class="invalid-feedback-label"
                        v-if="errors.has('clinicalCenter')">
                            <strong>{{ errors.first('clinicalCenter') }}</strong>
                        </span>
                </div>

                <div class="col-md-6 col-sm-12 timezone-list">
                  <v-select v-model="userTimezone"
                            :options="timezonesListNew"
                            name="timezone"
                            :filterable="false"
                            :onSearch="onSearchTimezone"
                            :class="{'is-invalid': errors.has('timezone'), 'is-clear': !userTimezone}"
                            v-validate="'required'"
                            data-vv-validate-on="none"
                            :data-vv-as="'validation.attributes.timezone' | trans">
                    <template slot="no-options">
                      <div @mousedown.stop="">
                        {{ 'user.type_the_timezone_to_search' | trans }}
                      </div>
                    </template>
                  </v-select>

                  <label class="mdc-floating-label"
                         :class="{ 'mdc-floating-label-error': errors.has('timezone') }">{{
                    'validation.attributes.timezone' | trans }}</label>
                  <span class="invalid-feedback-label"
                        v-if="errors.has('timezone')">
                        <strong>{{ errors.first('timezone') }}</strong>
                    </span>
                </div>

            </div>
            <div class="form-group row mt-3">
                <div class="col-md-6 col-sm-12">
                    <mdc-textfield id="code"
                                   :label="'user.client_code' | trans"
                                   type="text"
                                   name="code"
                                   :class="{'is-invalid': errors.has('code')}"
                                   v-validate="'required|alpha_dash|max:8'"
                                   v-model="user.code"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'user.client_code' | trans"/>

                    <span class="invalid-feedback"
                          v-if="errors.has('code')">
                                <strong>{{ errors.first('code') }}</strong>
                            </span>
                </div>

                <div class="col-md-6 col-sm-12">

                  <v-select id="therapists"
                            ref="therapistsSelect"
                            name="therapists"
                            label="id"
                            :options="therapistsNew"
                            :filterable="false"
                            :onSearch="onSearchTherapist"
                            :on-change="onChangeTherapist"
                            class="aut-dropdown"
                            :class="{'is-invalid': errors.has('therapists'), 'is-clear': !therapists.length &&  !searchText}"
                            v-model="user.therapists"
                            v-validate="'required'"
                            data-vv-validate-on="none"
                            data-vv-name="therapists"
                            :data-vv-as="'user.therapists' | trans"
                            multiple>
                    <template slot="no-options">
                      <div @mousedown.stop="">
                        {{ 'user.type_the_therapist_name_to_search' | trans }}
                      </div>
                    </template>
                    <template slot="option" slot-scope="option">
                      {{ option.displayName }}
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      {{ option.displayName }}

                    </template>
                  </v-select>

                  <label class="mdc-floating-label"
                         :class="{ 'mdc-floating-label-error': errors.has('therapists') }">{{
                    'user.therapists' | trans }}</label>
                  <span class="description-row">{{'user.start_therapist' | trans }}</span>


                  <span class="invalid-feedback-label"
                        v-if="errors.has('therapists') && searchText">
                            <strong>{{ 'errors.choose_therapist_from_list' | trans }}</strong>
                        </span>
                  <span class="invalid-feedback-label"
                        v-if="errors.has('therapists') && !searchText">
                        <strong>{{ errors.first('therapists') }}</strong>
                    </span>

                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                    <mdc-textfield id="username"
                                   :label="'user.username' | trans"
                                   type="text"
                                   name="username"
                                   :class="{'is-invalid': errors.has('username') || (validationError && validationError.username)}"
                                   v-validate="{required: true, max: 255, min: 5, unique_username: true, regex: /^[a-zA-Z0-9._@-]+$/}"
                                   v-model="user.username"
                                   autocomplete="new-username"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'user.username' | trans"/>

                  <span class="invalid-feedback"
                        v-if="validationError && validationError.username">
                        <strong>{{validationError.username.message}}</strong>
                    </span>

                  <span class="invalid-feedback"
                        v-if="errors.has('username') && errors.firstRule('username') != 'regex'">
                        <strong>{{ errors.first('username') }}</strong>
                    </span>

                  <span class="invalid-feedback"
                        v-if="errors.firstRule('username') === 'regex' ">
                        <strong>{{'validation.regex', {attribute: userName} | trans}}</strong>
                    </span>


                </div>
                <div class="col-md-6 col-sm-12">
                    <mdc-textfield id="displayName"
                                   :label="'user.display_name' | trans"
                                   type="text"
                                   name="displayName"
                                   :class="{'is-invalid': errors.has('displayName')}"
                                   v-validate="'required|max:255'"
                                   v-model="user.displayName"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'user.display_name' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('displayName')">
                            <strong>{{ errors.first('displayName') }}</strong>
                    </span>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                    <mdc-textfield id="password"
                                   ref="password"
                                   type="password"
                                   :label="isEdit ? 'validation.attributes.new_password' : 'validation.attributes.password'| trans"
                                   name="password"
                                   :class="{'is-invalid': errors.has('password')}"
                                   v-validate="'min:8|max:16'"
                                   v-model="user.password"
                                   v-bind:value="user.password"
                                   v-on:input="$emit('input', $event.target.value)"
                                   autocomplete="new-password"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.password' | trans"/>
                    <span class="invalid-feedback"
                          v-if="errors.has('password') || errors.has('form-pass.password')">
                            {{errors.first('password')  || errors.first('form-pass.password') }}
                        </span>
                    <small class="form-text text-muted">
                        {{'passwords.password_subscription' | trans}}
                    </small>
                </div>

                <div class="col-md-6 col-sm-12">
                    <mdc-textfield v-model="user.passwordConfirmation"
                                   :label="'validation.attributes.password_confirmation' | trans"
                                   v-bind:value="user.passwordConfirmation"
                                   v-on:input="$emit('input', $event.target.value)"
                                   type="password" name="password_confirmation"
                                   :class="{'is-invalid': errors.has('password_confirmation') || errors.has('newPasswordConfirmation') || errors.has('form-pass.password_confirmation')}"
                                   v-validate="'min:8|max:16|confirmed:password'"
                                   data-vv-validate-on="none"
                                   :data-vv-as="'validation.attributes.password_confirmation' | trans"/>
                    <span class="invalid-feedback"
                      v-if="errors.has('password_confirmation') || errors.has('newPasswordConfirmation') || errors.has('form-pass.password_confirmation')">
                        {{'validation.confirmed', {attribute: passwordLabel} | trans}}
                    </span>
                </div>
            </div>
        </form>

    </mdc-dialog>


</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import {Validator} from 'vee-validate';
  import therapist from '../../api/therapist';
  import client from '../../api/client';
  import clinicalCenter from '../../api/clinicalCenter';
  import lang from '../../../../lang/translator';
  import isEmpty from 'lodash/isEmpty';
  import isObject from 'lodash/isObject';
  import cloneDeep from 'lodash/cloneDeep';
  import debounce from 'lodash/debounce';
  import map from 'lodash/map';
  import Constants from '../Constants';
  import Loader from '../../../loader/components/Loader';
  import axios from 'axios';

  export default {
    name: 'ClientModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'data': {
        type: Object,
        default() {
          return {};
        },
      },
    },
    components: {
      Loader,
    },

    data() {
      return {
        user: {
          username: null,
          displayName: null,
          clinicalCenter: null,
          clinicalCenterId: null,
          code: null,
          therapists: [],
          therapistIds: [],
          timezone: null,
          password: null,
          passwordConfirmation: null
        },
        oldUser: {},
        userTimezone: null,
        therapists: [],
        clinicalCenters: [],
        timezonesList: [],
        isLoaded: true,
        searchText: null,
        searchTimezoneText: null,
        disabled: false,
        userName: lang.get('user.username'),
        passwordLabel: lang.get('validation.attributes.password'),
      }
    },
    async created() {
        Validator.extend('unique_username', {
            getMessage: attribute => lang.get('validation.unique',
                {attribute}),
            validate: async(username) => {
                let valid;
                let userId;
                if (this.isEdit) {
                  if (username === this.oldUser.username) {
                    return true;
                  } else {
                    userId = this.user.id
                  }
                }
                try {
                    let {data: response} = await axios.post(
                        '/registration/validate-username', {username, userId});
                    valid = response.data.valid;
                } catch (e) {
                    valid = false;
                }
                return {valid};
            },
        });

        if (!this.timezones) {
        this.isLoaded = false;
        await this.loadTimezones();
        this.isLoaded = true;
      }
    },
    computed: {
      ...mapState('client/repository', [
        'timezones',
        'validationError',
        'isChanged'
      ]),
      isEdit() {
        return !isEmpty(this.data);
      },
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
      timezonesListNew() {
        return this.timezonesList.filter((item) => {
          if (this.searchTimezoneText && this.searchTimezoneText.length > Constants.MIN_CHARACTERS_LENGTH) {
            if (item.label.replace(/^.{Constants.FIRST_TIMES_CHARACTERS_LENGTH}/, '').toLowerCase().indexOf(this.searchTimezoneText.toLowerCase()) > -1) {
              return item;
            }
          }
          else {
            return item;
          }
        });
      },
      clinicalCentersNew() {
        return this.clinicalCenters.filter((item) => {
          if (this.user.clinicalCenter) {
            return item.name !== this.user.clinicalCenter.name;
          }
          else {
            return item.name;
          }
        });
      },
      therapistsNew() {

        if (this.user.therapists) {

          return this.therapists.filter((item) => {
            let counter = 0;

            for (let therapist of this.user.therapists) {
              if (item.id === therapist.id) {
                counter++;
              }
            }
            if (counter === 0) {
              return true;
            }
          });
        } else {
          return this.therapists;
        }

      },
    },
    methods: {
      ...mapActions('client/repository', [
        'editItem',
        'addItem',
        'loadTimezones',
      ]),
      async onSearchTherapist(search, loading) {
        loading(true);
        await this.searchTherapists(therapist, search, this);
        this.searchText = search;
        loading(false);
      },
      onSearchTimezone(search) {
        this.searchTimezoneText = search;
      },
      searchTherapists: debounce(
          async(apiManager, search, vm) => {
            try {
              let response = await apiManager.search(search, 500, 1);
              vm.therapists = response.data.data.items;
            } catch (e) {
              console.error('Unknown API error occurred.');
            }
          },
          350,
      ),
      onChangeTherapist(val) {
        this.user.therapists = val;
        this.user.therapistIds = this.user.therapists
            ? map(this.user.therapists,
                therapist => therapist.id,
            )
            : [];
      },
      async searchClinicalCenter(search, perPage, page) {
        let response = await clinicalCenter.search(search, perPage, page);
        this.clinicalCenters = response.data.data.items;
      },
      onChangeClinicalCenter(val) {
        this.user.clinicalCenter = val;
        this.user.clinicalCenterId = this.user.clinicalCenter
            ? this.user.clinicalCenter.id
            : null;
      },
      async save() {
        this.disabled = true;
        let result = await this.$validator.validateAll();

        if (!result) {
          this.disabled = false;
          return;
        }

        try {
          this.user.timezone = this.userTimezone.id;

          let method = this.isEdit
              ? this.editItem
              : this.addItem;

          let response = method(this.$data.user);

        } catch (e) {

          console.info("e")
          console.info(e)
        } finally {
          this.disabled = false;
        }
      },
      reset() {
        Object.assign(this.$data, this.$options.data());
        this.searchText = null;
        this.errors.clear();
      },
      close() {
        this.reset();
        this.$emit('close');
      },
    },
    watch: {
      async visible(newValue, oldValue) {
        this.searchClinicalCenter('', Constants.PER_PAGE, Constants.PAGE);
        this.$refs.therapistsSelect.onEscape();
        this.searchText = null;
        if (!this.timezonesList.length) {
          for (let index in this.timezones) {
            this.timezonesList.push({id: index, label: this.timezones[index]});
          }
        }
        if (this.isEdit) {
          if (this.data.item && isObject(this.data.item)) {
            try {
              this.isLoaded = false;
              let response = await client.findById({id: this.data.item.id});
              this.user = response.data.data;
              this.oldUser = cloneDeep(this.user);
              this.therapists = this.user.therapists ? this.user.therapists : [];
              this.clinicalCenters.push(this.user.clinicalCenter);

              for (let index in this.timezones) {
                if (this.user.timezone == index) {
                  this.userTimezone =  this.timezones[index];
                }
              }
            } catch (e) {
              console.error('Unknown API error occurred.');
              this.isLoaded = true;
            } finally {
              this.isLoaded = true;
            }
          }
        }
      },
      async validationError(newValue) {
        if(newValue){
          this.errors.add({
            field: 'isValidationError',
            msg: newValue.message
          });
        } else{
          this.errors.clear()
        }
      },
      async isChanged(newValue) {
        if(newValue){
          this.close();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/user/client/components/Modal.vue